import '../scss/main.scss';
import { Hamburger } from './components/hamburger';
import { initProductsSlider } from './components/slider';
import { initWaterRipple } from './components/waterRipple';
import { initCustomCursor } from './components/customCursor';
import { initAgeGate } from './components/ageGate';
import { initHeaderFollow } from './components/headerFollow';
import { smoothScroll } from './components/smoothScroll';

/* Defining Site URL for images, so the website works on subfolder wordpress instances as well as global/absolute instances */
if (typeof themeSettings !== 'undefined') {
  __webpack_public_path__ = `${themeSettings.baseUrl}/wp-content/themes/sirema/dist/images/`;
}

document.addEventListener('DOMContentLoaded',  () => {
  initAgeGate();
  initHeaderFollow();
  Hamburger();
  initProductsSlider();
  if (document.querySelector('.front-page .hero')) {
    initWaterRipple('.front-page .hero', { scale: 3, intensity: 700, radius: 8, dampening: 0.99, blend: 'overlay' });
    initCustomCursor('.front-page .hero');
  }
  smoothScroll();
});